import { create } from 'zustand';
import {
  createJSONStorage,
  devtools,
  persist,
  subscribeWithSelector
} from 'zustand/middleware';
import { GlobalStore } from '@interfaces/global-store';
import { createUserStoreSlice } from '@services/store/create-user-store-slice';
import { AdminSlice } from './admin-store-slice';
import { DashboardSlice } from './dashboard-store-slice';
import { MemberSlice } from './member-store-slice';
import { preferencesSlice } from './preferences-slice';
import { secureStorage } from './secure-storage';
import { ToolsResourcesSlice } from './tools-resources-store-slice';

export const useGlobalStore = create<GlobalStore>()(
  devtools(
    subscribeWithSelector(
      persist(
        (...a) => ({
          ...createUserStoreSlice(...a),
          ...preferencesSlice(...a),
          ...AdminSlice(...a),
          ...MemberSlice(...a),
          ...DashboardSlice(...a),
          ...ToolsResourcesSlice(...a),
        }),
        {
          partialize: (state) =>
            Object.fromEntries(
              Object.entries(state).filter(([key]) => ![''].includes(key))
            ),
          name: 'global-store',
          storage: createJSONStorage(() => secureStorage)
        }
      )
    )
  )
);
